import routes from './routes';
import { createRouter, createWebHistory } from "vue-router";
import { applicationState } from '@/stores/application';
import { userState } from "@/stores/user";
import { TENANT_EMSMC, TENANT_CONE_HEALTH } from "@/lib/azure";

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const loginRoutes = [
    '/login',
    `/${TENANT_EMSMC}/login`,
    `/${TENANT_CONE_HEALTH}/login`,
];

router.beforeEach((to) => {
    const query = to.query;
    let modified = false

    if (!loginRoutes.includes(to.path)
        && to.path !== '/reset-request'
        && to.path !== '/confirm-reset-request'
        && to.path !== '/confirm-setup-request'
        && !userState.isLoggedIn) {
        return { ...to, path: '/login' };
    }

    if (!query.appId && applicationState.identifier) {
        query.appId = applicationState.identifier;
        modified = true;
    }

    if (to.path !== '/pending-actions' && userState.pending_actions.length > 0) {
        return { ...to, path: '/pending-actions' };
    }

    if (modified) {
        return { ...to, query };
    }
});

export default router;